// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssai-create-container {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    min-height: 100vh;
    padding: 2rem;
}

.ssai-card {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
    padding: 1.5rem;
    margin-bottom: 2rem;
}

.ssai-tabs {
    display: flex;
    border-bottom: 2px solid #eee;
    margin-bottom: 2rem;
}

.ssai-tab {
    padding: 1rem 2rem;
    cursor: pointer;
    font-weight: 600;
    color: #6c757d;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;
}

.ssai-tab.active {
    color: #0d6efd;
    border-bottom-color: #0d6efd;
}

.ssai-tab:hover {
    color: #0d6efd;
    background: rgba(13, 110, 253, 0.05);
}

.ssai-form-group {
    margin-bottom: 1.5rem;
}

.ssai-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #495057;
}

.ssai-input, .ssai-select, .ssai-textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 8px;
    background-color: #fff;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.ssai-input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.ssai-macro-btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s;
}

.ssai-macro-btn:hover {
    background: #e9ecef;
    border-color: #ced4da;
}

.ssai-url-display {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    border: 1px dashed #ced4da;
    font-family: monospace;
    word-break: break-all;
    min-height: 50px;
}

.ssai-btn-primary {
    background: linear-gradient(45deg, #0d6efd, #00d2ff);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 8px;
    font-weight: 600;
    transition: transform 0.2s;
}

.ssai-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
}

.ssai-tag-constructor {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 2rem;
}

.ssai-macro-sidebar {
    background: #fff;
    padding: 1rem;
    border-radius: 12px;
    border: 1px solid #eee;
}
`, "",{"version":3,"sources":["webpack://./src/AdvertiserPortal/Components/SSAICampaignCreate.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".ssai-create-container {\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    min-height: 100vh;\n    padding: 2rem;\n}\n\n.ssai-card {\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(10px);\n    border-radius: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.ssai-tabs {\n    display: flex;\n    border-bottom: 2px solid #eee;\n    margin-bottom: 2rem;\n}\n\n.ssai-tab {\n    padding: 1rem 2rem;\n    cursor: pointer;\n    font-weight: 600;\n    color: #6c757d;\n    transition: all 0.3s ease;\n    border-bottom: 3px solid transparent;\n}\n\n.ssai-tab.active {\n    color: #0d6efd;\n    border-bottom-color: #0d6efd;\n}\n\n.ssai-tab:hover {\n    color: #0d6efd;\n    background: rgba(13, 110, 253, 0.05);\n}\n\n.ssai-form-group {\n    margin-bottom: 1.5rem;\n}\n\n.ssai-label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    color: #495057;\n}\n\n.ssai-input, .ssai-select, .ssai-textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #ced4da;\n    border-radius: 8px;\n    background-color: #fff;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.ssai-input:focus {\n    border-color: #86b7fe;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.ssai-macro-btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.8rem;\n    border-radius: 4px;\n    border: 1px solid #dee2e6;\n    background: #fff;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.ssai-macro-btn:hover {\n    background: #e9ecef;\n    border-color: #ced4da;\n}\n\n.ssai-url-display {\n    background: #f8f9fa;\n    padding: 1rem;\n    border-radius: 8px;\n    border: 1px dashed #ced4da;\n    font-family: monospace;\n    word-break: break-all;\n    min-height: 50px;\n}\n\n.ssai-btn-primary {\n    background: linear-gradient(45deg, #0d6efd, #00d2ff);\n    color: white;\n    border: none;\n    padding: 0.75rem 2rem;\n    border-radius: 8px;\n    font-weight: 600;\n    transition: transform 0.2s;\n}\n\n.ssai-btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);\n}\n\n.ssai-tag-constructor {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 2rem;\n}\n\n.ssai-macro-sidebar {\n    background: #fff;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1px solid #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
